import { render, staticRenderFns } from "./ProcessoByCliente.vue?vue&type=template&id=00014622&"
import script from "./ProcessoByCliente.vue?vue&type=script&lang=js&"
export * from "./ProcessoByCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports